import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import { dataToReplenishmentReport } from '../parsings'
import { useParams } from 'react-router-dom'

const useGetReplenishmentReportList = () => {
  const Api = useApi()
  const params = useParams<any>()
  const parentSku = params?.sku as string

  const initialFilters = {
    page: 1,
    limit: 30,
    sale_history_months: 6,
    sort_by: 'sku/1',
    parent_sku: parentSku,
  }

  const {filters,  onSortingChange} = useFilters(initialFilters, {
    sortType: 'number',
  })
  const {data: response, isFetching} = Api.useGetQuery('/analytics/sold-products/replenishment-report', {
    queryId: 'replenishment-report-list',
    filters: filters,
    isToast: false,
    isErrorPageRedirection: false,
  })
  
  return {
    replenishmentReportList: dataToReplenishmentReport(response?.data),
    meta: response?.meta,
    isLoading: isFetching,
    filters,
    onSortingChange,
  }
}

export default useGetReplenishmentReportList
